module.exports = __webpack_public_path__ + "static/media/grocery_set_map_important.88c40dcb.svg";